import validate from 'validate.js'

export default function setValidateConfig(options = {}) {
  validate.options = {
    fullMessages: false,
    ...options
  }
}
